import { useState, useEffect, useRef, React} from 'react';
import { Link, useLocation } from "react-router-dom";
import '../style/navbar.css';

function Navbar() {
  const logo = require('../img/logo.png');
  const arrow = require('../img/arrow.png');
  const menuPng = require('../img/menu.png');
  const close = require ('../img/close.png');
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]); // re-runs every time menuOpen changes


  return (
    <div className='navigation-menu'>
        <ol>
            <li className='HeaderListHome'>
              <Link to={"/home"} className='HeaderHome'>
                <img src={logo} className='LogoPng'/>
              </Link>
            </li>
            <li className='MenuBtn MobileOnly'>
              <button className='ActMenuBtn' onClick={() => setMenuOpen(prev => !prev)}>
                <img src={menuPng} className='MenuImg'/>
              </button>
            </li>
            <div ref={menuRef} className={menuOpen ? 'HeaderWrapper Open' : 'HeaderWrapper'}>
              <li className='MenuBtn MobileOnly'>
                <button className='ActMenuBtn CloseImg' onClick={() => setMenuOpen(prev => !prev)}>
                  <img src={close} className='MenuImg CloseImg'/>
                </button>
              </li>
              <li className='HeaderListContact MobileOnly'><Link to={"/contact"} 
                className='HeaderContact'>
                  <p>Contact</p> <img src={arrow} className='ArrowPng'/>
              </Link></li>
              <li className='HeaderWork'><Link to={"/work"} 
                className={`Link ${location.pathname === '/work' ? 'ActiveLink' : ''}`}>
                  <p id='Work'>Work</p>
                </Link>
              </li>
              <li className='HeaderServices'><Link to={"/services"} 
                className={`Link ${location.pathname === '/services' ? 'ActiveLink' : ''}`}>
                  <p id='Services'>Services</p>
                </Link>
              </li>
              <li className='HeaderAbout'><Link to={"/about"} 
                className={`Link ${location.pathname === '/about' ? 'ActiveLink' : ''}`}>
                  <p id='About' >About</p>
                </Link>
              </li>
            </div>
            <li className='HeaderListContact'><Link to={"/contact"} className='HeaderContact'>
              <p>Contact</p> <img src={arrow} className='ArrowPng'/>
            </Link></li>
        </ol>
    </div>

  )
}

export default Navbar
